import apiClient from "./api";
const DOCTOR_API_BASE_URL = "/doctores";
class DoctoresService {
  getDoctores() {
    return apiClient.get(DOCTOR_API_BASE_URL);
  }
  agregarDoctor(doctor) {
    return apiClient.post(DOCTOR_API_BASE_URL, doctor);
  }
  updateDoctor(doctor, doctorId) {
    return apiClient.put(DOCTOR_API_BASE_URL + "/" + doctorId, doctor);
  }
  patchDoctor(doctor, doctorId) {
    return apiClient.patch(DOCTOR_API_BASE_URL + "/" + doctorId, doctor);
  }
  deleteDoctor(doctorId) {
    return apiClient.delete(DOCTOR_API_BASE_URL + "/" + doctorId);
  }
  async buscarDoctores(busqueda) {
    try {
      const response = await apiClient.post(`${DOCTOR_API_BASE_URL}/buscar`, { busqueda });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getDoctorPorId(doctorId) {
    try {
      const response = await apiClient.get(
        `${DOCTOR_API_BASE_URL}/${doctorId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new DoctoresService();